import styled from "styled-components";
import { Divider } from "@mui/material";
import AreaSourceSingleNav from "./AreaSourceSingleNav";
import { useState } from "react";
import AreaSourceFields from "../../AreaSourceFields";
import { PlaySource } from "type/panel/Panel.type";
import { SOURCE_TYPE_VALUES } from "constant/panel";

type Props = {
  sourceItem: PlaySource;
  sourceItemInd: number;
  onSourceDelete: Function;
  onSourceItemUpdate: Function;
};

const AreaSourceItem = ({
  sourceItem,
  sourceItemInd,
  onSourceDelete,
  onSourceItemUpdate,
}: Props) => {
  const [mode, setMode] = useState<string>("");

  const deleteHandle = () => {
    console.log("deleteHandle");
    onSourceDelete(sourceItemInd);
  };

  const editHandle = () => {
    setMode("edit");
  };

  const cancelHandle = () => {
    setMode("read");
  };

  const sourceFieldsUpdateHandle = (sourceFields: PlaySource) => {
    console.log("sourceFieldsUpdateHandle");
    onSourceItemUpdate(sourceItemInd, sourceFields);
    if (mode === "edit") {
      // setMode("read");
    }
    // setMode("read");
  };

  return (
    <Div>
      <Divider />

      <DivSourceItem>
        {mode !== "edit" && (
          <>
            <div>{sourceItem.type}</div>
            <div>duration: {sourceItem.duration} seconds</div>
            <div>start: {sourceItem.start} seconds</div>
            <div>wait: {sourceItem.wait} seconds</div>
            <div>repeat: {sourceItem.repeat} times</div>
            {sourceItem.type === SOURCE_TYPE_VALUES.TEXT && (
              <>
                <div>{sourceItem.content}</div>
              </>
            )}
            {sourceItem.type !== SOURCE_TYPE_VALUES.TEXT && (
              <div>{sourceItem.fileName}</div>
            )}
            <AreaSourceSingleNav onDelete={deleteHandle} onEdit={editHandle} />
          </>
        )}
        {mode === "edit" && (
          <AreaSourceFields
            defaultSourceFields={sourceItem}
            onSourceFieldsUpdate={sourceFieldsUpdateHandle}
            onCancel={cancelHandle}
          />
        )}
      </DivSourceItem>
    </Div>
  );
};

const Div = styled.div`
  margin-top: 1rem;
`;

const DivSourceItem = styled.div`
  margin-top: 1rem;
`;

export default AreaSourceItem;
